import { render, staticRenderFns } from "./BoxComunicacoes.vue?vue&type=template&id=192210e8&"
import script from "./BoxComunicacoes.vue?vue&type=script&lang=js&"
export * from "./BoxComunicacoes.vue?vue&type=script&lang=js&"
import style0 from "./BoxComunicacoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports